/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeApproveCommissionStatementRequest, serializeCommissionStatementDto, type ApproveCommissionStatementRequest, type CommissionStatementDto, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/{commissionStatementId}/approve
 */
export interface ApproveRequestBuilder extends BaseRequestBuilder<ApproveRequestBuilder> {
    /**
     * Moves a statement from InReview to Approved, clearing it for payment. Only a statement currently in review can be approved — a Pending one must be submitted first, and a disputed one has to be returned to review before it can be approved. Approval is not final: a statement can still be disputed after it, right up until it is marked paid. `user` is required and is written into the statement's history against the approval; it is recorded as sent and is not checked against the caller's identity.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ApproveCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionStatementDto | undefined>;
    /**
     * Moves a statement from InReview to Approved, clearing it for payment. Only a statement currently in review can be approved — a Pending one must be submitted first, and a disputed one has to be returned to review before it can be approved. Approval is not final: a statement can still be disputed after it, right up until it is marked paid. `user` is required and is written into the statement's history against the approval; it is recorded as sent and is not checked against the caller's identity.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ApproveCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ApproveRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/{commissionStatementId}/approve";
/**
 * Metadata for all the requests in the request builder.
 */
export const ApproveRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ApproveRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeApproveCommissionStatementRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
